module.exports = __webpack_public_path__ + "static/media/man.32839b30.png";